import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { inject, observer } from 'mobx-react';

import Container from '@material-ui/core/Container';

import compose from 'helpers/compose';
import Background from 'components/Layout/Background';
import ControlButtons from 'components/ControlButtons';

import { RootStore } from 'stores/rootStore';
import { Params } from 'pages/Accounts/Edit/accountEditRoutes';
import { AccountDetailStore } from 'stores/account/accountDetailStore';
import BankAccounts from 'pages/Accounts/Edit/components/BankAccounts';
import { ViewMode } from 'pages/Accounts/Edit/components/viewModes';

import { AppTheme } from 'components/AppTheme';

interface Props {
  rootStore: RootStore;
  accountDetailStore: AccountDetailStore;
  readOnly: boolean;
  //tabChange: Function;
  //openEdit: () => void; // async
}

const DetailBankAccounts: React.FC<Props> = ({ rootStore, accountDetailStore, readOnly }) => {
  const { accountId } = useParams<Params>();
  const { t } = useTranslation();

  return (
    <AppTheme>
      <Container maxWidth="md">
        <Background afterMenu={readOnly}>
          <BankAccounts
            accountId={accountId}
            rootStore={rootStore}
            //openEdit={openEdit}
            readOnly={readOnly}
            viewMode={ViewMode.DETAIL}
          />
        </Background>
      </Container>

      {!readOnly && (
        <ControlButtons
          isSubmitting={false}
          nextText={t(accountDetailStore.nextStepLabel)}
          onBack={() => accountDetailStore.goBack()}
          backText={t(accountDetailStore.prevStepLabel)}
          onNext={() => accountDetailStore.goFwd()}
        />
      )}
    </AppTheme>
  );
};

export default compose(inject('rootStore'), observer)(DetailBankAccounts);
